import { MouseEvent } from 'react';
import { isMacOs } from 'react-device-detect';
import { ROUTES } from '../Base.constants';
import { ApiError } from '../services/api-error.model';
import { isCommandKeyOn, isControlKeyOn, isLeftMouseButtonEvent, isWheelMouseButtonEvent } from './inputEventUtils';
import { COMPANY_TAG_PREFIX, isCompanyTag, MUNICIPAL_TAG_PREFIX } from './tagUtils';

export const shouldOpenInNewTab = (e: MouseEvent): boolean => {
  return (isLeftMouseButtonEvent(e) && (isMacOs ? isCommandKeyOn(e) : isControlKeyOn(e))) || isWheelMouseButtonEvent(e);
};

export const shouldNavigate = (isDesktop: boolean, openArticlePreviewOnClick?: boolean, isCompact?: boolean): boolean =>
  !isDesktop || (!openArticlePreviewOnClick && !isCompact);

export const openWindowInNewTab = (route: string): void => {
  window.open(`${window.location.origin}${route}`, '_blank');
};

// Allows to navigate user outside the current MFE to a different MFE application.
// It is a workaround to avoid an issue where react router uses a catch-all route for unknown routes and redirects to 404 page.
export const navigateToAnotherMfe = (route: string): void => {
  window.history.pushState(undefined, '', route);
};

export const getIssuerRoute = (tag: string): string =>
  isCompanyTag(tag)
    ? ROUTES.company(tag.replace(COMPANY_TAG_PREFIX, ''))
    : ROUTES.municipal(tag.replace(MUNICIPAL_TAG_PREFIX, ''));

export const isNotFound = (error: ApiError | null | undefined): boolean =>
  [400, 404].includes(Number(error?.response?.status));
